<div class="page-section-input-container"
     [class.selected]="selected"
     [class.static]="static">
  <div class="noneSelectable page-section-title"
       contenteditable="false"
       [class.empty]="titleControl?.value === ''"
       [attr.data-placeholder]="section.section_title && section.title_control.value ? '':'Enter the section title'">
    {{ (section.title_control.valueChanges|async) || section.title_control.value }}
  </div>
</div>
